import React, { useCallback } from 'react';
import { Link, useHistory } from 'react-router-dom';
import { FiPower } from 'react-icons/fi';
import { Container, Header, HeaderContent, Profile } from './styles';
import { useAuth } from '~/hooks/Auth';
import Logo from '~/assets/logos/Logo';

const AdminHeader: React.FC = () => {
  const { signOut, user } = useAuth();
  const history = useHistory();

  // Transforma o nome do usuário para ter a primeira letra maiúscula
  const formattedUserName =
    user && 'name' in user && typeof user.name === 'string'
      ? user.name.charAt(0).toUpperCase() + user.name.slice(1)
      : 'Usuário';

  const handleSignOut = useCallback(() => {
    signOut();
    history.push('/admin/login'); // Redireciona para a página de login
  }, [signOut, history]);
  return (
    <Container>
      <Header>
        <HeaderContent>
          {/* Você pode adicionar o logo da empresa aqui se quiser */}
          <Profile>
            <Link to="/dashboard" title="Ir para o Dashboard">
              <Logo color="#202020" className="me-2 logo" />
            </Link>
            <div>
              <span>Bem-vindo(a),</span>
              <strong>{formattedUserName}</strong>
            </div>
          </Profile>

          <button type="button" onClick={handleSignOut}>
            <FiPower />
          </button>
        </HeaderContent>
      </Header>
    </Container>
  );
};

export default AdminHeader;
